"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchTermsStore = void 0;
var mobx_1 = require("mobx");
var mobx_utils_1 = require("mobx-utils");
var lodash_es_1 = require("lodash-es");
var urls = {
    'search_terms': '/api/search_terms_vw'
};
var SearchTermsStore = /** @class */ (function () {
    function SearchTermsStore(itemsBusquedaBuilder) {
        var _this = this;
        this.itemsBusquedaBuilder = itemsBusquedaBuilder;
        this.availableSearchTerms = {
            acciones_colectivas: [],
            afectaciones_ecologicas: [],
            afectaciones_sociales: [],
            estados: [],
            oposicion: [],
            hechos_violencia: [],
            proyectos: [],
            conflictos: [],
            tipo_despliegue: [],
        };
        this.searchTermsLoaded = false;
        this.fetchSearchTerms = function () {
            if (_this.searchTermsLoaded)
                return;
            fetch(urls.search_terms)
                .then(function (res) { return res.json(); })
                .then(function (json) {
                var st = json[0];
                st.proyectos.sort();
                st.estados.sort();
                st.tipo_despliegue.sort();
                st.hechos_violencia.sort();
                st.acciones_colectivas.sort();
                st.afectaciones_sociales.sort();
                st.afectaciones_ecologicas.sort();
                mobx_1.transaction(function () {
                    _this.availableSearchTerms = st;
                    _this.searchTermsLoaded = true;
                });
            });
        };
        this.getDefaultLogicOpForNombre = mobx_utils_1.createTransformer(function (nombre) {
            var ib = _this.itemsBusqueda.find(function (ib) { return ib.nombre === nombre; });
            return ib ? ib.defaultLogicOp : 'y';
        });
        mobx_1.onBecomeObserved(this, 'availableSearchTerms', this.fetchSearchTerms);
    }
    Object.defineProperty(SearchTermsStore.prototype, "itemsBusqueda", {
        get: function () {
            return this.itemsBusquedaBuilder(this.availableSearchTerms);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SearchTermsStore.prototype, "searchItemsByCategory", {
        get: function () {
            return lodash_es_1.fromPairs(this.itemsBusqueda.map(function (searchCategory) { return ([searchCategory.nombre, searchCategory.items.map(function (item) {
                    return ({
                        nombre: searchCategory.nombre,
                        dbname: searchCategory.dbname,
                        defaultLogicOp: searchCategory.defaultLogicOp,
                        sourceType: searchCategory.sourceType,
                        item: searchCategory.nombre,
                        label: item,
                        value: item
                    });
                })
            ]); }));
        },
        enumerable: false,
        configurable: true
    });
    SearchTermsStore.prototype.getSearchItemBy = function (category, value) {
        var searchCategory = this.searchItemsByCategory[category];
        if (!searchCategory)
            return undefined;
        return searchCategory.find(function (si) { return si.value === value; });
    };
    __decorate([
        mobx_1.observable
    ], SearchTermsStore.prototype, "availableSearchTerms", void 0);
    __decorate([
        mobx_1.observable
    ], SearchTermsStore.prototype, "searchTermsLoaded", void 0);
    __decorate([
        mobx_1.action
    ], SearchTermsStore.prototype, "fetchSearchTerms", void 0);
    __decorate([
        mobx_1.computed
    ], SearchTermsStore.prototype, "itemsBusqueda", null);
    __decorate([
        mobx_1.computed
    ], SearchTermsStore.prototype, "searchItemsByCategory", null);
    return SearchTermsStore;
}());
exports.SearchTermsStore = SearchTermsStore;
